import {
  CreateQuestionnaireCategoryBulkInput,
  CreateQuestionnaireCategoryInput,
  CreateQuestionnaireCategoryWithGroupsInput,
} from '@/models/gen/graphql';
import { CreateQuestionnaireCategoryBulkDocument, CreateQuestionnaireCategoryWithGroupsDocument } from '@/api/queries';

import graphApi from '@/api';
import { searchCategoriesWithMetadata } from './searchQuestionnaireCategories';

type NewCategory = Omit<CreateQuestionnaireCategoryInput, 'active' | 'answerTypeId' | 'sortOrder'>;

const [runCreateCategory] = graphApi(CreateQuestionnaireCategoryBulkDocument);
const [runCreateCategoryWithGroups] = graphApi(CreateQuestionnaireCategoryWithGroupsDocument);

const toCreateInput = async (category: NewCategory): Promise<CreateQuestionnaireCategoryInput> => {
  const { totalCount } = await searchCategoriesWithMetadata({ roleId: category?.roleId });
  return { ...category, active: 1, sortOrder: (totalCount || 0) + 1 };
};

export const createCategory = async (category: NewCategory) => {
  const input: CreateQuestionnaireCategoryBulkInput = { values: [await toCreateInput(category)] };
  const res = await runCreateCategory({ input });
  return res?.createQuestionnaireCategoryBulk?.output?.map(({ node }) => node) || [];
};

export const createCategoryWithGroups = async (category: NewCategory, groupIds: string[] = []) => {
  const input: CreateQuestionnaireCategoryWithGroupsInput = { values: [{ category: await toCreateInput(category), groupIds }] };
  const res = await runCreateCategoryWithGroups({ input });
  return res?.createQuestionnaireCategoryWithGroups?.output?.map(({ category }) => category) || [];
};

export default createCategory;
